<div
	class="crew-list-container"
	[ngClass]="layout"
>
	<app-crew-chip
		*ngFor="let member of sortedCrew"
		[crew]="member"
		[showIcons]="true"
		[displayFormat]="displayFormat"
	></app-crew-chip>
</div>